import { TableBody, TableBorderless, TableCell, TableHead, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { FarmData } from '@/modules/Report/Report.schema';

export const FarmBasicInfoTable = ({ data }: { data: FarmData }) => (
  <TableBorderless>
    <TableBody>
      <TableRow>
        <TableHead className="w-1/2">Farm Name</TableHead>
        <TableCell className="text-right">{data.farmInfo.generalInfo.farmName}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Farm ID</TableHead>
        <TableCell className="text-right">{data.farmInfo.generalInfo.farmId}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Core Extraction Dates</TableHead>
        <TableCell className="text-right">{data.farmInfo.generalInfo.coreExtractionDates}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Sample Analysis Dates</TableHead>
        <TableCell className="text-right">{data.farmInfo.generalInfo.sampleAnalysisDates}</TableCell>
      </TableRow>
    </TableBody>
    <TableBody className={cn('border-t border-secondary')}>
      <TableRow>
        <TableHead className="w-1/2">Land Use</TableHead>
        <TableCell className="text-right">{data.farmInfo.generalInfo.farmDescription}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Typical Soil Type</TableHead>
        <TableCell className="text-right">{data.farmInfo.terrainInfo.typicalSoilType}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Typical Terrain Type</TableHead>
        <TableCell className="text-right">{data.farmInfo.terrainInfo.terrainType}</TableCell>
      </TableRow>
    </TableBody>
    <TableBody className={cn('border-t border-secondary')}>
      <TableRow>
        <TableHead className="w-1/2">Total Included Area (ha)</TableHead>
        <TableCell className="text-right">{data.farmInfo.areaInfo.totalArea}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Total Cores</TableHead>
        <TableCell className="text-right">{data.farmInfo.coresInfo.totalCores}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Cores per Hectare</TableHead>
        <TableCell className="text-right">{data.farmInfo.coresInfo.coresPerHectare}</TableCell>
      </TableRow>
      <TableRow>
        <TableHead className="w-1/2">Mean Soil Depth (mm)</TableHead>
        <TableCell className="text-right">{data.farmInfo.terrainInfo.meanSoilDepth}</TableCell>
      </TableRow>
    </TableBody>
  </TableBorderless>
);
